import { useMemo } from "react";

type Props = {
  size?: "small" | "large";
};

const LoadingIndicator: React.FC<Props> = ({ size = "large" }) => {
  const gapClass = useMemo(() => {
    switch (size) {
      case "small":
        return "gap-1";
      case "large":
        return "gap-6";
      default:
        return "gap-6";
    }
  }, [size]);

  const sizeClass = useMemo(() => {
    switch (size) {
      case "small":
        return "h-1.5 w-1.5";
      case "large":
        return "h-2.5 w-2.5";
      default:
        return "h-2.5 w-2.5";
    }
  }, [size]);

  const animationDelayClass = (index: number) => {
    switch (index) {
      case 1:
        return "[animation-delay:0.5s]";
      case 2:
        return "[animation-delay:1s]";
      default:
        return "";
    }
  };

  return (
    <div
      data-testid="loading-indicator"
      className={`flex justify-center ${gapClass}`}
    >
      {Array.from({ length: 3 }, (_, index) => (
        <div
          key={index}
          className={`${sizeClass} animate-loadingDot rounded-full bg-blue900 [animation-play-state:running] ${animationDelayClass(index)}`}
        />
      ))}
    </div>
  );
};

export default LoadingIndicator;
